import { useCallback, useEffect, useRef, useState } from 'react';
import { useDependency } from '../../../contexts/DependencyProvider';
import { useViewInfo } from '../../../hooks/UseViewInfo';
import { CLOSED_TITLES, normalizeText, statusColor, toBase64Unicode } from '../../../utils/helperUtil';
import useBrowserName from '../../../hooks/UseBrowserName';
import useScreenSize from '../../../hooks/UseScreenSize';
import { ToastQueue } from '@react-spectrum/toast';
import { useAsyncList } from 'react-stately';
import {
  Flex,
  View,
  ProgressCircle,
  Grid,
  Heading,
  Content,
  ListBox,
  Item,
  IllustratedMessage,
  Link,
  Accordion,
  DialogContainer,
  DisclosureTitle,
  Key,
  Disclosure,
  DisclosurePanel
} from '@adobe/react-spectrum';
import NotFound from '@spectrum-icons/illustrations/NotFound';
import FilterComponent from './components/FilterComponent';
import HeaderComponent from './components/HeaderComponent';
import { LayoutDefinition } from '../../../infra/protected/Layout/LayoutDefinitions';
import CardComponent from './components/CardComponent';
import FilterSearchTextBox from './components/FilterSearchDatePicker';
import { RootState } from '../../../state/store';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import { updateAppInfo } from '../../../state/userWebLayout/userWebLayoutSlice';
import { DeleteItemRequest } from '../../../services/soap/item/requests/DeleteItemRequest';
import styles from './Calendar.module.css';
import { DeleteConfirmationDialog } from '../finder/components/DeleteConfirmationDialog';
import EventListTable from './components/EventListTable';
import { GetSchedulerSettingsRequest, SettingsItemType } from '../../../services/soap/scheduler/requests/GetSchedulerSettingsRequest';
import { EventTaskCompletedIcon, EventTaskFutureIcon, EventTaskUncompletedIcon } from '../../../components/protected/Icons/IconsLib';
import { CircleFill } from 'react-bootstrap-icons';
import moment from 'moment';
import { ListEventRequest } from '../../../services/soap/scheduler/requests/ListEventRequest';
import { GetEventRequest } from '../../../services/soap/scheduler/requests/GetEventRequest';
import EventDetailsView from './components/EventDetailView';
import EventDetailViewMobile from './components/EventDetailViewMobile';
import AddUpdateEvent from './components/AddUpdateEvent';
import { UpdateEventRequest } from '../../../services/soap/scheduler/requests/UpdateEventRequest';
import { EventItem } from '../../../services/soap/dataObjects/EventItem';
import { useDeviceDetection } from '../../../hooks/UseDeviceDetection';
import { ListUserRequest } from '../../../services/soap/access/requests/ListUserRequest';
import { DeleteEventRequest } from '../../../services/soap/scheduler/requests/DeleteEventRequest';
import { addKey, useKeyboardShortcuts } from '../../../hooks/UseKeyboardShortcuts';
import { getTypeOfWorkFromLogin, TypeOfWorkBinding } from '../../../utils/LoginUtils';
interface Character {
  id: string;
  title: string;
}

export function Calendar() {
  const browserName = useBrowserName();
  const screenSize = useScreenSize();
  const { t } = useTranslation('calendar');
  const _t = (key: string) => t(`calendar_detail.${key}`, { ns: 'calendar' });
  const _tt = (key: string) => t(`calendar_common.${key}`, { ns: 'calendar' });
  const _tm = (key: string) => t(`calendar_messages.${key}`, { ns: 'calendar' });
  const { isMobile } = useViewInfo();
  const { store, schedulerService, itemService, accessService } = useDependency();
  const dataStore = useSelector((state: any) => state.userWebLayout.appInfos);
  const selectedApp = useSelector((state: RootState) => state.userWebLayout.selectedAppId);
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [showLoader, setShowLoader] = useState(true);
  const [showLoaderDetail, setShowLoaderDetail] = useState(true);
  const [rowsData, setRowsData] = useState<any>([]);
  const [columnsData, setColumnsData] = useState<any>([]);
  const [pageView, setPageView] = useState<string>('Full');
  const [selectedKeys, setSelectedKeys] = useState<Set<any>>();
  const [eventStatusList, setEventStatusList] = useState<any>([]);
  const [typeofWorkList, setTypeofWorkList] = useState<any>([]);
  const [definition, setDefinition] = useState<LayoutDefinition | null>(null);
  const [showMobileDetailView, setShowMobileDetailView] = useState<boolean>(false);
  const [stopLoadData, setStopLoadData] = useState<boolean>(false);
  const [searchedValue, setSearchedValue] = useState<string>('');
  const [selectedItem, setSelectedItem] = useState<any | null>(null);
  const [selectedDataRow, setSelectedDataRow] = useState<any>({});
  const serviceActivityValue = useRef<string>('');
  const queryParams = useRef<any>({ FILTER: { COL: [] } });
  const totalProductListRec = useRef<number>(0);
  const offSetLimit = useRef<number>(0);
  const dataRef = useRef<any>({});
  const [showAdd, setShowAdd] = useState(false);
  const [addFormType, setAddFormType] = useState<string>('');
  const [isEdit, setIsEdit] = useState(false);
  const [params] = useSearchParams();
  const [showCards, setShowCards] = useState<boolean>(true);
  const [isOpen, setOpen] = useState(false);
  const [todayEvents, setTodayEvents] = useState<any>([]);
  const [tomorrowEvents, setTomorrowEvents] = useState<any>([]);
  const [futureEvents, setFutureEvents] = useState<any>([]);
  const [todayLabel, setTodayLabel] = useState<string>('');
  const [tomorrowLabel, setTomorrowLabel] = useState<string>('');
  const [futureLabel, setFutureLabel] = useState<string>('');
  const [expandedSectionKey, setExpandedSectionKey] = useState<Set<Key>>(new Set(['today']));
  const [upComing7DaysEvents, setUpComing7DaysEvents] = useState<any>([]);
  const [past7DaysCompletedEvents, setPast7DaysCompletedEvents] = useState<any>([]);
  const [past3MonthsUnCompletedEvents, setPast3MonthsUnCompletedEvents] = useState<any>([]);
  const deviceInfo = useDeviceDetection(isMobile);
  const [showFilter, setshowFilter] = useState<boolean>(false);
  const [userData, setUserData] = useState<any>([]);
  const [showUpdateDescLoader, setShowUpdateDescLoader] = useState<boolean>(false);
  const PAGE_SIZE = 50;

  useEffect(() => {
    if (state.appKey && dataStore[state.appKey]) {
      if (dataStore[state.appKey].pageView) {
        dataRef.current.pageView = dataStore[state.appKey].pageView;
        setPageView(dataStore[state.appKey].pageView);
        return;
      }
    }
  }, [dataStore.appInfos, state.appKey]);

  useEffect(() => {
    (async () => {
      if (params.has('id')) {
        setShowCards(false);
      }
      setShowLoader(true);
      setShowLoaderDetail(true);
      queryParams.current = { FILTER: { COL: [] } };
      serviceActivityValue.current = '';
      setPageView('Full');
      setSearchedValue(moment(new Date()).format('YYYY-MM-DD'));
      Promise.all([getEventStatusList(), getTypeofWorkList(), getUserData()]);
    })();
  }, []);

  useEffect(() => {
    if (selectedApp !== '') {
      listEventList.reload();
    }
  }, [selectedApp]);

  useEffect(() => {
    return () => {
      dispatch(
        updateAppInfo({
          key: state.appKey,
          data: {
            pageView: dataRef.current.pageView,
          },
        })
      );
    };

  }, []);

  const getFormSettings = useCallback(
    async (settingId: string) => {
      setColumnsData([
        { key: 'name', name: 'Name' },
        { key: 'refId', name: 'Ref.Id' },
        { key: 'statusName', name: 'Product Status' },
        { key: 'amount', name: 'Price', isNumeric: true },
      ]);
    },
    [selectedApp]

  );

  const getUserCount = async () => {
    let userList = await accessService.listUser(new ListUserRequest(store.Server, store.SessionId, true, undefined, undefined, '1'));
    if (userList.result === 'OK') {
      return userList.count;
    }
  };

  const getUserData = async () => {
    const totalRecords = await getUserCount();
    let userResp = await accessService.listUser(new ListUserRequest(store.Server, store.SessionId, true, totalRecords));
    if (userResp.result === 'OK') {
      const formattedArray = userResp.USERS.map(({ USER }) => ({
        id: USER.id,
        name: `${USER.name1} ${USER.name3}`,
      }));
      setUserData(formattedArray);

      return formattedArray;
    }
  }

  const getEventStatusList = useCallback(async () => {
    const statusArray: any = [];
    let res: any = await schedulerService.getSchedulerSettings(new GetSchedulerSettingsRequest(store.Server, store.SessionId,
      '1', SettingsItemType.EVENT_ITEM_TYPE, 300, 0));
    if (res.result === 'OK' && res.ITEMS.length > 0) {
      res?.ITEMS.forEach((status: any) => {
        const { ident, title, color } = status.ITEM;
        let colorString = statusColor(color);
        statusArray.push({ ident, title, color: colorString });
      });

      statusArray.unshift({ ident: 'All states', title: '', color: 'black' });
      setEventStatusList(statusArray);
      return statusArray;
    }
  }, [selectedApp]);

  // const getTypeofWorkList = async () => {
  //     const bindedTypeOfWork = getTypeOfWorkFromLogin(TypeOfWorkBinding.Expense, store.session.organization);

  //     let typeofWorkContextResp: any = await schedulerService.getTypeOfWorkForContext(new GetTypeOfWorkForContextRequest(store.Server, store.SessionId, true));

  //     const filteredTypeofWork = typeofWorkContextResp
  //                                 .SETTINGS
  //                                 .sort((a: any, b: any) => a.SETTING.typeOfWorkName.localeCompare(b.SETTING.typeOfWorkName))
  //                                 .filter((setting: any) => setting.SETTING.contextType == selectedItem?.item_type_id)
  //                                 .filter((setting: any) => bindedTypeOfWork.some((typeOfWork: Status) => typeOfWork.ident === setting.SETTING.typeOfWork))
  //                                 .map((setting: any) => ({
  //                                   ITEM:{
  //                                     ident: setting.SETTING.typeOfWork,
  //                                     title: setting.SETTING.typeOfWorkName,
  //                                   }
  //                                 }));
  //     setTypeofWorkList(filteredTypeofWork);
  //   };

  const getTypeofWorkList = async () => {
    const bindedTypeOfWork = getTypeOfWorkFromLogin(TypeOfWorkBinding.Event, store.session.organization);

    // console.table(bindedTypeOfWork);

    const statusArray: any = []

    // let scheduleResp = await schedulerService.getSchedulerSettings(new GetSchedulerSettingsRequest(
    //   store.Server,
    //   store.SessionId,
    //   '4',
    //   SettingsItemType.EVENT_ITEM_TYPE, 50, 0));

    // if (scheduleResp.result === "OK") {
    //   console.table(scheduleResp.ITEMS);

    // }

    bindedTypeOfWork?.forEach((status: any) => {
      const { ident, title, color, defaultFor, validFor } = status;
      let colorString = statusColor(color);
      statusArray.push({ ident, title, color: colorString, defaultFor, validFor });
    });
    setTypeofWorkList(statusArray);

    return statusArray
  };

  const loadEvents = async (statusArray: any, standardStatus: any, rangeStart: Date, rangeEnd: Date, eventType: string) => {
    try {
      if (eventType === 'future') {
        rangeStart.setHours(0, 0, 0);
        rangeEnd.setHours(23, 59, 59);
      }
      const requestParams = mapFiltersToRequest(queryParams.current.FILTER);
      let startDateFormatted = ''
      let endDateFormatted = ''
      if (requestParams.date && requestParams.date != 'null') {
        let startDate = new Date(requestParams.date);
        let endDate = addDays(new Date(requestParams.date), 7);
        startDate.setHours(0, 0, 0);
        endDate.setHours(23, 59, 59);
        startDateFormatted = moment(startDate).format('YYYY-MM-DDTHH:mm:ss').toString();
        endDateFormatted = moment(endDate).format('YYYY-MM-DDTHH:mm:ss').toString();
      } else {
        startDateFormatted = moment(rangeStart).format('YYYY-MM-DDTHH:mm:ss').toString();
        endDateFormatted = moment(rangeEnd).format('YYYY-MM-DDTHH:mm:ss').toString();
      }
      setShowLoader(true);
      let queryFilters: any = {
        userFilter: 1,
        orderBy1Desc: false,
        orderBy1Field: 'dateFrom',
        anyTime: 0,
        folderId: '',
        projectId: '',
        activityId: '',
        dateOfInterest: 0,
        standardStatus: standardStatus,
        rangeEnd: endDateFormatted,
        rangeStart: startDateFormatted,
        groupUsers: 1,
        userId: store.UserId,
        limit: PAGE_SIZE,
        offset: offSetLimit.current,
        USER: requestParams && requestParams.users && requestParams.users.length > 0 ? requestParams.users : [{ id: store.UserId }]
      };

      if (requestParams.entryType && requestParams.entryType != 'All states') {
        queryFilters.entryType = requestParams.entryType;
      }
      //   switch (selectedItem?.type) {
      //     case FPADataTypes.FOLDER:
      //       queryParams.folderId = String(selectedItem?.id);
      //       break;
      //     case FPADataTypes.PROJECT:
      //       queryParams.folderId = String(selectedItem?.parent_id);
      //       queryParams.projectId = String(selectedItem?.id);
      //       break;
      //     case FPADataTypes.ACTIVITY:
      //       queryParams.folderId = String(selectedItem?.parent?.parent_id);
      //       queryParams.projectId = String(selectedItem?.parent_id);
      //       queryParams.activityId = String(selectedItem?.id);
      //       break;
      //   }

      let eventRes: any = await schedulerService.listEvent(
        new ListEventRequest(store.Server, store.SessionId, {
          ...queryFilters,
        })
      );
      if (eventRes?.result == 'OK' && eventRes.ITEMS) {
        let eventData: any = eventRes.ITEMS.ITEM.map((item: any) => ({
          id: item.ident + '_' + Math.floor(Math.random() * 10000),
          ident: item.ident,
          dateTo: moment(item.dateTo).format('MM/DD/YYYY | HH:mm A'),
          title: item.title,
          entryTypeName: item.entryTypeName,
          user: item.USER,
          userList: item.userList,
          solutionStatus: getStatusColor(statusArray, item.solutionStatus),
          icon: getEventIcon(eventType),
          apa: item.apa,
          statusColor: getStatusBackGroundColor(eventType),
          projectName: item.projectName,
          folderName: item.folderName,
          activityName: item.activityName,
          location: item.location
        }));
        //setRowsData((prev: any) => [...prev, eventData]);

        return eventData;
      } else {
        //ToastQueue.info(t('no_results', { ns: 'layout_components' }), { timeout: 50 });
        return [];
      }
    } finally {
      setShowLoader(false);
    }
  };

  const addDays = (d: Date, days: number) => {
    const x = new Date(d);
    x.setDate(x.getDate() + days);
    return x;
  };

  const loadEventsFuturList = async (statusArray: any, standardStatus: any, startDate: any, endDate: any, eventListtype: any) => {
    return loadEvents(statusArray, standardStatus, startDate, endDate, eventListtype);
  };

  const loadEventsPastLineCompleted = async (statusArray: any) => {
    const start = addDays(new Date(), -7); // 7 days past
    const endDate = addDays(new Date(), -1);
    return loadEvents(statusArray, 1, start, endDate, 'pastCompleted');
  };

  const loadEventsPastLineUnCompleted = async (statusArray: any) => {
    const start = addDays(new Date(), -90); // 3M days past
    const endDate = addDays(new Date(), -1);
    return loadEvents(statusArray, '0', start, endDate, 'pastUnCompleted');
  };

  const getStatusColor = (statusArray: any, solutionStatus: any) => {
    const statusObj = statusArray.find((obj: any) => obj.ident == solutionStatus);
    return (
      <>
        <CircleFill style={{ paddingRight: '10px' }} size={'18px'} color={statusObj?.color} /> {statusObj?.title}
      </>
    );
  };

  const getEventIcon = (eventType: string) => {
    if (eventType === 'future') {
      return <EventTaskFutureIcon size={32} />;
    } else if (eventType === 'pastCompleted') {
      return <EventTaskCompletedIcon size={32} />;
    } else if (eventType === 'pastUnCompleted') {
      return <EventTaskUncompletedIcon size={32} />;
    }
  };

  const getStatusBackGroundColor = (eventType: string) => {
    if (eventType === 'future') {
      return '#1976D2';
    } else if (eventType === 'pastCompleted') {
      return '#8BC34A';
    } else if (eventType === 'pastUnCompleted') {
      return '#F72B1C';
    }
  };

  const getEventListcount = async () => {
    await getFormSettings('');
    totalProductListRec.current = 20000000;
    return totalProductListRec.current;
  };

  const mapFiltersToRequest = (filters: { COL: any[] }) => {
    const requestParams: {
      countOnly?: boolean;
      entryType?: string;
      status?: string;
      refId?: string;
      manufacturer?: string;
      date?: string;
      users?: Array<{ id: string }>;
    } = {
    };

    filters.COL.forEach(filter => {
      if (filter.name === 'contains') {
        requestParams.date = `${filter.value}`;
      }
      if (filter.name === 'user') {
        const raw = filter.value;
        const first =
          raw instanceof Set ? Array.from(raw)[0]
            : Array.isArray(raw) ? raw[0]
              : raw;

        if (first && String(first).trim().toLowerCase() === 'all users') {
          return;
        }
        const ids =
          raw instanceof Set
            ? Array.from(raw)
            : Array.isArray(raw)
              ? raw
              : typeof raw === "string"
                ? raw.split(",")
                : raw != null
                  ? [raw]
                  : [];

        requestParams.users = ids
          .map((id) => String(id).trim())
          .filter(Boolean)
          .map((id) => ({ id }));
      }
      if (filter.name === 'manufacturer') {
        requestParams.manufacturer = filter.value;
      }
      if (filter.name === 'status') {
        requestParams.status = filter.value;
      }
      if (filter.name === 'customState') {
        const raw = filter.value;
        const first =
          raw instanceof Set ? Array.from(raw)[0]
            : Array.isArray(raw) ? raw[0]
              : raw;

        if (first && String(first).trim().toLowerCase() === 'all states') {
          return;
        }
        requestParams.entryType = first;
      }
    });
    return requestParams;
  };

  const toMomentDay = (x?: string | Date | moment.Moment) => {
    if (!x) return moment().startOf('day');
    if ((x as any)._isAMomentObject) return (x as moment.Moment).clone().startOf('day');
    if (x instanceof Date) return moment(x).startOf('day');

    // try common formats
    const m = moment(x as string, ['MM/DD/YYYY', 'YYYY-MM-DD'], true);
    return (m.isValid() ? m : moment(x)).startOf('day');
  };

  // keep your parsers
  const parseDateTo = (s: string) =>
    moment(s, ['MM/DD/YYYY | hh:mm A', 'MM/DD/YYYY | HH:mm A', 'MM/DD/YYYY | HH:mm'], true);
  const parseDay = (s: string) => moment(s.split('|')[0].trim(), 'MM/DD/YYYY', true);

  const loadEventList = async (): Promise<any[]> => {
    try {
      if (stopLoadData) return rowsData;

      const statusArray = await getEventStatusList();
      const end = addDays(new Date(), 7); // 7 days future
      const [eventsFuture, eventsPastCompleted, eventPastUncompleted] = await Promise.all([
        loadEventsFuturList(statusArray, undefined, new Date(), end, 'future'),
        loadEventsPastLineCompleted(statusArray),
        loadEventsPastLineUnCompleted(statusArray)
      ]);

      const sortByDateDesc = (arr: any[]) =>
        [...arr].sort(
          (a, b) => parseDateTo(b.dateTo).valueOf() - parseDateTo(a.dateTo).valueOf()
        );
      const byAsc = (a: any, b: any) =>
        parseDateTo(a.dateTo).valueOf() - parseDateTo(b.dateTo).valueOf();

      const anchor: moment.Moment = (() => {
        const vals = eventsFuture
          .map((e: any) => parseDay(e.dateTo))
          .filter((m: moment.Moment) => m.isValid())
          .map((m: any) => m.startOf('day').valueOf());
        const min = Math.min(...vals);
        return Number.isFinite(min) ? moment(min) : moment().startOf('day');
      })();

      const dayDiff = (e: any) => {
        const d = parseDay(e.dateTo);
        return d.isValid() ? d.diff(anchor, 'days') : Number.NaN; // 0=today,1=tomorrow,2..6=future
      };

      const dateFormat = (d: moment.Moment) => {
        var dayOfWeek = [_t('sunday'), _t('monday'), _t('tuesday'), _t('wednesday'), _t('thursday'), _t('friday'), _t('saturday')];
        var monthNames = [_t('jan'), _t('feb'), _t('mar'), _t('apr'), _t('may'), _t('jun'), _t('jul'), _t('aug'), _t('sep'), _t('oct'), _t('nov'), _t('dec')];
        return `${dayOfWeek[d.day()]} ${d.date()} ${monthNames[d.month()]} ${d.year()}`;
      };
      // --- strict, non-overlapping buckets relative to anchor ---
      const todayArr = eventsFuture.filter((e: any) => dayDiff(e) === 0).sort(byAsc);
      const tomorrowArr = eventsFuture.filter((e: any) => dayDiff(e) === 1).sort(byAsc);
      const futureArr = eventsFuture.filter((e: any) => {
        const d = dayDiff(e);
        return d >= 2 && d <= 6; // exactly next 5 days
      }).sort(byAsc);

      // --- labels ---
      const todayLabel = dateFormat(anchor);
      const tomorrowLabel = dateFormat(anchor.clone().add(1, 'day'));

      // Final order: TODAY → TOMORROW → FUTURE → extras
      const sortedData = [
        ...todayArr,
        ...tomorrowArr,
        ...futureArr
      ];


      setTodayEvents?.(todayArr);
      setTomorrowEvents?.(tomorrowArr);
      setFutureEvents?.(futureArr);

      setTodayLabel?.(todayLabel);
      setTomorrowLabel?.(tomorrowLabel);
      setFutureLabel?.(_t("next_5_days"));
      setExpandedSectionKey?.(new Set(['today', ...(tomorrowArr.length > 0 ? ['tomorrow'] : []), ...(futureArr.length > 0 ? ['future'] : [])]));
      if (params.has('id')) {
        getLayout(+params.get('id')!, undefined, statusArray);
      } else {
        getLayout([todayArr[0]?.ident], todayArr[0], statusArray);
      }


      setUpComing7DaysEvents(sortedData);
      setPast7DaysCompletedEvents(sortByDateDesc(eventsPastCompleted));
      setPast3MonthsUnCompletedEvents(sortByDateDesc(eventPastUncompleted));
      setRowsData([...sortedData, ...eventsPastCompleted, ...eventPastUncompleted]);
      return sortedData;
    } finally {
      setShowLoader(false);
    }
  };

  const getLayout = async (selectedId: any, selectedRow?: any, statusArray?: any) => {
    try {
      setShowLoaderDetail(true);
      const eventResult = await schedulerService.getEvent(
        new GetEventRequest(
          store.Server,
          store.SessionId,
          selectedId.toString(),
          store.UserId.toString()
        )
      );

      if (eventResult.result !== 'OK') return;
      const items = normalizeEventTask(eventResult.ITEM);
      const single = items ?? null;
      const statusItem = getClosedStatusIdent(eventStatusList);
      const statusId = statusItem ? statusItem.ident : '';
      const eventDetail = selectedRow ? selectedRow : rowsData.find((x: any) => x.ident === selectedId.toString());
      const result = single && single.ident
        ? {
          id: single.ident ?? single?.id,
          ident: single.ident ?? single?.id + '_' + Math.floor(Math.random() * 10000),
          title: single.title,
          entryTypeName: single.entryTypeName ?? eventDetail?.entryTypeName,
          user: eventDetail?.user,
          userList: eventDetail?.userList,
          solutionStatus: single.solutionStatus,
          status: single.solutionStatus,
          statusName: statusItem ? statusItem.title : '',
          statusId: statusItem ? statusItem.ident : '',
          icon: eventDetail?.icon,
          apa: single.apa ?? eventDetail?.apa,
          statusColor: eventDetail?.statusColor,
          activityId: single.activityId,
          activityName: single.activityName ?? eventDetail?.activityName,
          projectId: single.projectId,
          projectName: single.projectName ?? eventDetail?.projectName,
          folderId: single.folderId,
          folderName: single.folderName ?? eventDetail?.folderName,
          location: single.location,
          description: single.description,
          headId: single.headId,
          repeat: single.repeat,
          dateFrom: fmtDate(single.dateFrom),
          dateTo: fmtDate(single.dateTo),
          timeFrom: fmtTime(single.dateFrom),
          timeTo: fmtTime(single.dateTo),
          isChargeable: single?.chargeable === '1',
          isPrivate: single?.isPrivate === '1',
          isRepeat: single?.repeat ? true : false,
          isResolved: single?.solutionStatus === statusId,
        }
        : null;

      if (!result) return;
      setSelectedDataRow({ ...single, isRepeat: single?.repeat ? true : false, isChargeable: single?.chargeable === '1', isPrivate: single?.isPrivate === '1' });
      setSelectedItem(result);
      setSelectedKeys(new Set([eventDetail?.id ?? single.id]));
      return result;
    } catch (err) {
      console.error('getLayout error:', err);
    } finally {
      setShowLoaderDetail(false);
    }
  };


  const listEventList = useAsyncList<Character>({
    async load({ cursor, signal }) {
      try {
        // if (!selectedApp) {
        //   return { items: [], cursor: undefined };
        // }

        const currentPage = cursor ? parseInt(cursor, 10) : 0;
        const estimatedLoadedCount = currentPage * PAGE_SIZE;
        // if (cursor && estimatedLoadedCount >= totalProductListRec.current) {
        //   return { items: rowsData, cursor: undefined };
        // }

        const totalRecords = currentPage === 0 ? await getEventListcount() : totalProductListRec.current;

        if (signal?.aborted) {
          console.log('Request was aborted');
        }
        const offset = Math.min(PAGE_SIZE * currentPage, totalRecords ?? 0);
        offSetLimit.current = offset;

        const items = await loadEventList();
        const hasMoreItems = offset + (items?.length || 0) < (totalRecords ?? 0);
        const nextCursor = hasMoreItems ? String(currentPage + 1) : undefined;

        return {
          items: items || [],
          cursor: nextCursor,
        };
      } catch (error) {
        console.error('Error loading event list:', error);
        ToastQueue.negative(t('error_loading_data', { ns: 'layout_components' }) || 'Error loading data', { timeout: 3000 });
        return { items: [], cursor: undefined };
      } finally {
        setShowLoader(false);
        setshowFilter(true);
      }
    },
    async sort({ items, sortDescriptor }) {
      if (!sortDescriptor) return { items };

      const { column, direction } = sortDescriptor;

      return {
        items: [...items].sort((a: any, b: any) => {
          const aValue = a[column];
          const bValue = b[column];
          let result = 0;
          if (typeof aValue === 'string' && typeof bValue === 'string') {
            result = aValue.localeCompare(bValue);
          } else if (aValue < bValue) {
            result = -1;
          } else if (aValue > bValue) {
            result = 1;
          }

          return direction === 'descending' ? -result : result;
        }),
      };
    },

    getKey: item => item.id,
  });

  const reloadEvent = useCallback((filterParams: any) => {
    setStopLoadData(false);
    queryParams.current = filterParams;
    totalProductListRec.current = 0;
    offSetLimit.current = 0;
    setShowCards(true);
    listEventList.reload();
  }, []);

  const handleTableRowClick = (rowId: any): void => {
    let selectedRow = rowsData.find((item: any) => item.id === rowId);
    if (selectedKeys?.has(rowId.currentKey) || rowId === null) {
      return;
    } else {
      setShowLoaderDetail(true);
      setSelectedKeys(new Set([rowId]));
      setShowCards(false);
      setPageView('Full');
      dataRef.current.pageView = 'Full';
      if (!selectedRow) {
        setSelectedDataRow({});
        setSelectedKeys(undefined);
        setDefinition(null);
        return;
      }
      getLayout(selectedRow.ident, selectedRow);
    }
  };

  const handleListRowClick = (rowId: any): void => {
    let selectedRow = rowsData.find((item: any) => item.id === rowId.currentKey);
    if (selectedKeys?.has(selectedRow.ident) || rowId === null) {
      return;
    } else {
      setShowLoaderDetail(true);
      setSelectedKeys(rowId);
      setPageView('Full');
      dataRef.current.pageView = 'Full';
      if (!selectedRow) {
        setSelectedDataRow({});
        setSelectedKeys(undefined);
        setDefinition(null);
        return;
      }
      getLayout(selectedRow.ident);
    }
  };

  const handleRowClickMobile = (rowId: any): void => {
    const nameSearchExists = queryParams.current.FILTER.COL.find((col: any) => col.name === 'contains');
    if (nameSearchExists) {
      setSearchedValue(nameSearchExists.value);
    }
    setSelectedKeys(undefined);
    let selectedRow = rowsData.find((item: any) => item.id === rowId.currentKey);
    if (!selectedRow) {
      setSelectedDataRow({});
      setSelectedKeys(undefined);
      setDefinition(null);
      return;
    }
    getLayout(selectedRow.ident);
    setShowMobileDetailView(true);
  };

  const handleViewChange = (view: string) => {
    setPageView(view);
    setShowCards(true);
    dataRef.current.pageView = view;
  };

  const fmtDate = (dt?: string | null) =>
    dt ? moment(dt).format('MM/DD/YYYY') : undefined;
  const fmtTime = (dt?: string | null) =>
    dt ? moment(dt).format('HH:mm') : undefined;

  type YesNo = '0' | '1';
  type User = { id: string; };

  function normalizeEventTask(payload: any) {
    if (!payload) return null;
    const root = payload.ITEM && typeof payload.ITEM === "object"
      ? payload.ITEM
      : payload;

    if (!root || typeof root !== "object") {
      return null;
    }

    let baseEvent: any = null;
    const users: any[] = [];
    let repeat: any = null;

    const keys = Object.keys(root);
    const numericKeys = keys.filter(k => /^\d+$/.test(k)).sort((a, b) => Number(a) - Number(b));

    if (numericKeys.length > 0) {
      numericKeys.forEach((key, index) => {
        const entry = root[key];
        if (!entry || typeof entry !== "object") return;

        if (index === 0) {
          const { USER, REPEAT, ...rest } = entry;
          baseEvent = { ...rest };

          if (USER) users.push(USER);
          if (REPEAT) repeat = REPEAT;
        } else {
          if (entry.USER) users.push(entry.USER);
        }
      });

      if (root.REPEAT) {
        repeat = root.REPEAT;
      }
    } else {
      const { USER, REPEAT, ...rest } = root;
      baseEvent = { ...rest };

      if (USER) users.push(USER);
      if (REPEAT) repeat = REPEAT;
    }

    if (!baseEvent) {
      return null;
    }

    return {
      ...baseEvent,
      users,
      repeat: repeat || null,
      result: payload.result,
      taskIdent: payload.ident,
      taskName: payload.name
    };
  }

  function toUserList(obj: any): Array<User> | undefined {
    if (Array.isArray(obj)) return obj;
    if (obj && typeof obj === 'object') {
      const u = obj as User;
      return [{ id: u.id }];
    }
    return undefined;
  }

  const Loader = () => (
    <Flex width="100%" justifyContent="center" marginTop={10}>
      <ProgressCircle aria-label="Loading…" isIndeterminate />
    </Flex>
  );

  const NoResultsMessage = () => (
    <Flex direction="row" width="100%" alignContent="center" justifyContent="center">
      <IllustratedMessage>
        <NotFound />
        <Heading>{t('no_results', { ns: 'layout_components' })}</Heading>
        <Content>{t('try_another_search', { ns: 'layout_components' })}</Content>
      </IllustratedMessage>
    </Flex>
  );

  const getHeight = (baseHeight: number) => {
    if (browserName === 'Chrome') {
      return `${baseHeight - 120}px`;
    } else if (browserName === 'Safari') {
      return `${baseHeight - 120}px`;
    } else {
      return `${baseHeight - 120}px`;
    }
  };

  const getWidth = () => {
    return `95%`;
  };

  const detailStyle = {
    height: getHeight(screenSize.height - 20),
  };

  const cardStyle = {
    height: 'auto',
    width: getWidth(),
    top: 0,
  };

  const filterStyle = {
    height: getHeight(screenSize.height + 60),
    overflow: 'hidden auto',
  };

  const handleAddNew = () => {
    setShowAdd(true);
  };

  const handleAddNewClose = () => {
    setShowAdd(false);
    setIsEdit(false);
    setAddFormType('');
  };

  const handleEditClick = (data: boolean) => {
    if (data) {
      setIsEdit(data);
      setShowAdd(true);
    }
  };

  const handleEditClickTable = async (item: any) => {
    setSelectedKeys(new Set([item.ident]));
    const eventDetail = rowsData.find((x: any) => x.ident === item.ident);
    getLayout(item.ident, eventDetail);
    setShowAdd(true);
    setIsEdit(true);
  }

  const refreshDetailView = async (eventId: any) => {
    setShowLoaderDetail(true);
    // const p = await getLayout(eventId,undefined,undefined) as Character;
    // const index = listEventList.items.findIndex((row: any) => row.id === eventId);
    // if (index !== -1) {
    //   listEventList.items[index] = { ...listEventList.items, ...p };
    // }

    loadEventList();
    setSelectedKeys(new Set([eventId]));
  };

  const handleRefreshAddNewEvent = async (eventData: any) => {
    setShowLoaderDetail(true);
    setSelectedKeys(new Set([eventData.id]));
    const event = await getLayout(eventData.id, eventData, undefined) as Character;
    const data = [...rowsData];
    setRowsData([...data, event]);
    setTodayEvents((prev: any) => [event, ...prev]);
  };

  const handleEventDelete = async (data: any) => {
    const deleteEventResult = await schedulerService.deleteEvent(new DeleteEventRequest(store.Server, store.SessionId, { ident: data.id }));
    if (deleteEventResult.result === 'OK') {
      setOpen(false);
      ToastQueue.positive(_tm('event_deleted'), { timeout: 3000 });
      setSelectedItem(null);
      setSelectedDataRow({});
      setSelectedKeys(undefined);
      listEventList.reload();
    } else {
      ToastQueue.negative(deleteEventResult.EXCEPTION.message, { timeout: 3000 });
    }
  };

  function getClosedStatusIdent(statusList: any[]) {
    const candidates = (statusList || [])
      .filter(s => s?.ident && typeof s.ident === "string")
      .filter(s => s.ident !== "All states")      // ignore fake row
      .filter(s => (s.title || "").trim() !== ""); // ignore blanks

    const closed = candidates.find(s => CLOSED_TITLES.has(normalizeText(s.title)));

    console.log('close status', closed)

    return closed;
  }

  const updateEventStatus = async (isSelected: boolean, ident: string, isMulti: boolean) => {
    if (!isSelected) return;
    // const statusItem = eventStatusList.find((item: any) => (item.title === 'Uzavřen' || item.title === 'Closed'));
    // const statusId = statusItem ? statusItem.ident : '';

    const statusItem = getClosedStatusIdent(eventStatusList);

    const payLoad: EventItem = {
      ...selectedDataRow,
      completed: new Date().toISOString(),
      multiEventTask: isMulti ? '1' : '0',
      solutionStatus: statusItem?.ident,
      headUserId: store.UserId.toString(),
      USER: toUserList(selectedDataRow.userList) || [{ id: store.UserId.toString() }],
    }
    setShowLoaderDetail(true);
    try {
      const response = await schedulerService.updateEvent(new UpdateEventRequest(store.Server, store.SessionId, payLoad));
      if (response.result === 'OK') {
        setShowLoaderDetail(false);
        setSelectedItem(null);
        setSelectedDataRow({});
        setSelectedKeys(undefined);
        getLayout(ident);
        ToastQueue.positive(_tm('event_closed'), { timeout: 3000 });
      } else {
        setShowLoaderDetail(false);
        ToastQueue.negative(response.EXCEPTION.message || 'Failed to update event status', { timeout: 3000 });
      }
    } catch (error) {
      console.error('Error updating event status:', error);
    }
  };

  const updateEventDescription = async (description: string) => {
    setShowUpdateDescLoader(true);
    const payLoad: EventItem = {
      ...selectedDataRow,
      description: toBase64Unicode(description),
      headUserId: store.UserId.toString(),
    }
    try {
      const response = await schedulerService.updateEvent(new UpdateEventRequest(store.Server, store.SessionId, payLoad));
      if (response.result === 'OK') {
        setShowUpdateDescLoader(false);
        ToastQueue.positive(_tm('event_description_updated'), { timeout: 3000 });
      } else {
        ToastQueue.negative(response.EXCEPTION.message || 'Failed to update task status', { timeout: 3000 });
        setShowUpdateDescLoader(false);
      }
    } catch (error) {
      setShowUpdateDescLoader(false);
      console.error('Error updating task status:', error);
    }
  };

  useKeyboardShortcuts([...addKey('c', { ctrl: true, shift: true }, () => handleAddNew())], true);

  const shouldUseDesktopLayout = !deviceInfo.shouldUseMobileLayout() || ((deviceInfo.isTablet || deviceInfo.isIPad) && deviceInfo.orientation === 'landscape');

  return (
    <>

      {!shouldUseDesktopLayout ? (
        <>
          {!showMobileDetailView && showCards && (
            <>
              <FilterComponent onFilterChange={reloadEvent} filterParams={queryParams.current} />
              <View position={'relative'} width={'100%'} height={'100%'} UNSAFE_className={styles.card_list_parent}>
                <Flex direction={'column'} position={'absolute'} width={'100%'} top={'72px'} left={'0%'} alignItems={'start'} justifyContent={'start'} gap={'12px'} maxHeight={'100vh'}>
                  {showLoader ? (
                    <Loader />
                  ) : (
                    <Accordion width={'100%'} isQuiet expandedKeys={expandedSectionKey} onExpandedChange={setExpandedSectionKey}>
                      <Disclosure id="today">
                        <DisclosureTitle>{todayLabel}</DisclosureTitle>
                        <DisclosurePanel>
                          <ListBox
                            autoFocus
                            id="eventCards"
                            selectionMode="single"
                            onSelectionChange={(rowId) => handleRowClickMobile(rowId)}
                            marginStart={'15px'}
                            minHeight={'130px'}
                            defaultSelectedKeys={selectedKeys}
                            selectedKeys={selectedKeys}
                            aria-label="Event Cards"
                            items={todayEvents}
                            isLoading={listEventList.isLoading}
                            UNSAFE_style={{ ...cardStyle, marginTop: 13 }}
                          >
                            {(item: any) => (
                              <Item key={item.id} textValue={item.title}>
                                <CardComponent item={item} />
                              </Item>
                            )}
                          </ListBox>
                        </DisclosurePanel>
                      </Disclosure>
                      <Disclosure id="tomorrow">
                        <DisclosureTitle>{tomorrowLabel}</DisclosureTitle>
                        <DisclosurePanel>
                          <ListBox
                            autoFocus
                            id="eventCards"
                            selectionMode="single"
                            onSelectionChange={(rowId) => handleRowClickMobile(rowId)}
                            marginStart={'15px'}
                            minHeight={'130px'}
                            defaultSelectedKeys={selectedKeys}
                            selectedKeys={selectedKeys}
                            aria-label="Event Cards"
                            items={listEventList.items}
                            isLoading={listEventList.isLoading}
                            UNSAFE_style={{ ...cardStyle, marginTop: 13 }}
                          >
                            {item => (
                              <Item key={item.id} textValue={item.title}>
                                <CardComponent item={item} />
                              </Item>
                            )}
                          </ListBox>
                        </DisclosurePanel>
                      </Disclosure>
                      <Disclosure id="future">
                        <DisclosureTitle>{futureLabel}</DisclosureTitle>
                        <DisclosurePanel>
                          <ListBox
                            autoFocus
                            id="eventCards"
                            selectionMode="single"
                            onSelectionChange={(rowId) => handleRowClickMobile(rowId)}
                            marginStart={'15px'}
                            minHeight={'130px'}
                            defaultSelectedKeys={selectedKeys}
                            selectedKeys={selectedKeys}
                            aria-label="Event Cards"
                            items={listEventList.items}
                            isLoading={listEventList.isLoading}
                            UNSAFE_style={{ ...cardStyle, marginTop: 13 }}
                          >
                            {item => (
                              <Item key={item.id} textValue={item.title}>
                                <CardComponent item={item} />
                              </Item>
                            )}
                          </ListBox>
                        </DisclosurePanel>
                      </Disclosure>
                    </Accordion>
                  )}
                </Flex>
                <Flex
                  direction={'column'}
                  position={'absolute'}
                  width={'calc(100% - 32px)'}
                  top={'16px'}
                  right={'16px'}
                  left={'16px'}
                  alignItems={'start'}
                  justifyContent={'start'}
                  UNSAFE_className={styles.search_parent}
                >
                  <Flex direction={'row'} alignSelf={'stretch'} height={'40px'} flexShrink={0} alignItems={'center'} justifyContent={'end'} gap={'8px'}>
                    <FilterSearchTextBox onSearchChange={reloadEvent} filterParams={queryParams.current} serachedText={searchedValue} />
                  </Flex>
                </Flex>
                <Flex
                  direction={'row'}
                  position={'fixed'}
                  right={'16px'}
                  bottom={'95px'}
                  height={'48px'}
                  justifyContent={'center'}
                  alignItems={'center'}
                  gap={'8px'}
                  UNSAFE_className={styles.add_new_parent}
                >
                  <Link onPress={handleAddNew} isQuiet aria-label="Actions" UNSAFE_className={styles.add_new_btn}>
                    <i className="bi bi-plus fs-5">
                      <View UNSAFE_className={styles.add_new_btn_text}>{_tt('button_add_new')}</View>
                    </i>
                  </Link>
                </Flex>
              </View>
            </>
          )}

          {(showMobileDetailView || !showCards) && (
            <>
              <View id="top" position={'relative'} width={'100%'} height={'64px'} overflow={'hidden'} UNSAFE_className={styles.layout_header_parent}>
                <Flex gap={'size-150'} position={'relative'} top={'calc(50% - 15px)'} left={'15px'} height={'30px'} UNSAFE_className={styles.layout_header_btn_back}>
                  <Link
                    onPress={() => {
                      setStopLoadData(true);
                      setShowMobileDetailView(false);
                      setShowCards(true);
                    }}
                  >
                    <i className="bi bi-chevron-left fs-5"></i>
                  </Link>
                  <span>{_t("event_details")}</span>
                </Flex>
              </View>
              <Flex direction="column" alignItems={'start'} justifyContent={'center'} UNSAFE_className={styles.detailsHolder} UNSAFE_style={{ padding: '0px', paddingTop: '0px' }}>
                {selectedItem && (
                  <>
                    {showLoader ? (
                      <Loader />
                    ) : (
                      <>
                        <View UNSAFE_className={styles.service_status_bar} marginBottom={'5px'} marginTop={'0px'} UNSAFE_style={{ backgroundColor: selectedItem.statusColor }}></View>
                        <EventDetailViewMobile
                          event={selectedItem}
                          selectedDataRow={selectedDataRow}
                          eventStatusList={eventStatusList}
                          updateEventStatus={updateEventStatus}
                          updateEventDescription={updateEventDescription}
                          showUpdateLoader={showUpdateDescLoader}
                          onEdit={handleEditClick}
                          onDelete={() => setOpen(true)}
                        />
                      </>
                    )}
                  </>
                )}
              </Flex>
            </>
          )}
        </>
      ) :
        (showCards ? (
          <Grid
            areas={
              (deviceInfo.isTablet || deviceInfo.isIPad)
                ? pageView === 'Full'
                  ? ['header header', 'filter filter', 'card detail']
                  : ['header header', 'filter filter', 'detail detail']
                : pageView === 'Full'
                  ? ['filter header header', 'filter card detail']
                  : ['filter header header', 'filter detail detail']
            }
            columns={{
              base: ((deviceInfo.isTablet || deviceInfo.isIPad) && deviceInfo.orientation === 'landscape')
                ? ['35%', '65%']
                : ['245px', '28%', 'auto'],
              L: ((deviceInfo.isTablet || deviceInfo.isIPad) && deviceInfo.orientation === 'landscape')
                ? ['35%', '65%']
                : ['245px', '28%', 'auto']
            }}
            rows={
              (deviceInfo.isTablet || deviceInfo.isIPad)
                ? ['auto', 'auto', '1fr']
                : ['auto', '1fr']
            }
            height="100%"
            width="100%"
            UNSAFE_style={{ backgroundColor: '#f5f6f9', padding: '0px', margin: '0px', overflow: 'hidden' }}
          >
            {!(deviceInfo.isTablet || deviceInfo.isIPad) && (
              <View gridArea="filter">
                {showFilter ? (
                  <FilterComponent onFilterChange={reloadEvent} filterParams={queryParams.current} filterStyle={filterStyle} />
                ) : (
                  <Flex
                    height={'100%'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    UNSAFE_style={{ backgroundColor: 'white' }}
                  >
                    <Loader />
                  </Flex>
                )}
              </View>
            )}
            <View width={'100%'} gridArea="header" UNSAFE_style={pageView == 'Full' ? {} : { height: '100%' }}>
              <HeaderComponent
                onPageViewChange={handleViewChange}
                autoChanged={pageView}
                filterParams={queryParams.current}
                onSearchChange={reloadEvent}
                fpaTypeCategory={serviceActivityValue.current}
                onAddNew={handleAddNew}
              />
            </View>
            {(deviceInfo.isTablet || deviceInfo.isIPad) && (
              <View gridArea="filter" UNSAFE_style={{ height: '60px', backgroundColor: 'white', borderBottom: '1px solid #e0e0e0' }}>
                <FilterComponent onFilterChange={reloadEvent} filterParams={queryParams.current} filterStyle={filterStyle} />
              </View>
            )}
            {pageView == 'Full' ? (
              <>
                {showLoader ? (
                  <Loader />
                ) : (
                  <>
                    <View gridArea="card" UNSAFE_style={{ backgroundColor: '#f5f6f9', overflow: 'auto' }}>
                      {rowsData?.length > 0 ? (
                        <Accordion width={'100%'} isQuiet expandedKeys={expandedSectionKey} onExpandedChange={setExpandedSectionKey}>
                          <Disclosure id="today">
                            <DisclosureTitle>{todayLabel}</DisclosureTitle>
                            <DisclosurePanel>
                              <ListBox
                                autoFocus
                                id="eventCards"
                                selectionMode="single"
                                onSelectionChange={(rowId) => handleListRowClick(rowId)}
                                marginStart={'15px'}
                                defaultSelectedKeys={selectedKeys}
                                selectedKeys={selectedKeys}
                                aria-label="Event Cards"
                                items={todayEvents}
                                isLoading={listEventList.isLoading}
                                UNSAFE_style={{ ...cardStyle, marginTop: 13 }}
                              >
                                {(item: any) => (
                                  <Item key={item.id} textValue={item.title}>
                                    <CardComponent item={item} />
                                  </Item>
                                )}
                              </ListBox>
                            </DisclosurePanel>
                          </Disclosure>
                          <Disclosure id="tomorrow">
                            <DisclosureTitle>{tomorrowLabel}</DisclosureTitle>
                            <DisclosurePanel>
                              <ListBox
                                autoFocus
                                id="eventCards"
                                selectionMode="single"
                                onSelectionChange={(rowId) => handleListRowClick(rowId)}
                                // onLoadMore={listEventList.items.length > 45 ? listEventList.loadMore : undefined}
                                marginStart={'15px'}
                                // minHeight={'130px'}
                                defaultSelectedKeys={selectedKeys}
                                selectedKeys={selectedKeys}
                                aria-label="Event Cards"
                                items={tomorrowEvents}
                                isLoading={listEventList.isLoading}
                                UNSAFE_style={{ ...cardStyle, marginTop: 13 }}
                              >
                                {(item: any) => (
                                  <Item key={item.id} textValue={item.title}>
                                    <CardComponent item={item} />
                                  </Item>
                                )}
                              </ListBox>
                            </DisclosurePanel>
                          </Disclosure>
                          <Disclosure id="future">
                            <DisclosureTitle>{futureLabel}</DisclosureTitle>
                            <DisclosurePanel>
                              <ListBox
                                autoFocus
                                id="eventCards"
                                selectionMode="single"
                                onSelectionChange={(rowId) => handleListRowClick(rowId)}
                                marginStart={'15px'}
                                defaultSelectedKeys={selectedKeys}
                                selectedKeys={selectedKeys}
                                aria-label="Event Cards"
                                items={futureEvents}
                                isLoading={listEventList.isLoading}
                                UNSAFE_style={{ ...cardStyle, marginTop: 13 }}
                              >
                                {(item: any) => (
                                  <Item key={item.id} textValue={item.title}>
                                    <CardComponent item={item} />
                                  </Item>
                                )}
                              </ListBox>
                            </DisclosurePanel>
                          </Disclosure>
                        </Accordion>
                      ) : (
                        <View marginTop={'13px'}>
                          <NoResultsMessage />
                        </View>
                      )}
                    </View>
                    <View
                      gridArea="detail"
                      backgroundColor={'static-white'}
                      borderRadius={'large'}
                      padding={'size-100'}
                      paddingTop={'0'}
                      marginTop={'17px'}
                      UNSAFE_style={detailStyle}
                      width={'98%'}
                      UNSAFE_className={styles.detailView}
                    >
                      {showLoaderDetail ? (
                        <Loader />
                      ) : (
                        <View height="100%" UNSAFE_className={styles.detailsHolder} UNSAFE_style={{ overflow: 'hidden auto' }} marginStart={'10px'}>
                          {selectedItem && (
                            <>
                              {rowsData?.length > 0 ? (
                                <>
                                  <View UNSAFE_className={styles.service_status_bar} UNSAFE_style={{ backgroundColor: selectedItem.statusColor }}></View>
                                  <View height={'2px'}>&nbsp;</View>
                                  <EventDetailsView
                                    event={selectedItem}
                                    productStatusList={eventStatusList}
                                    updateEventStatus={updateEventStatus}
                                    onEdit={handleEditClick}
                                    onDelete={() => setOpen(true)}
                                    updateEventDescription={updateEventDescription}
                                    showUpdateLoader={showUpdateDescLoader}
                                  />
                                </>
                              ) : (
                                <View marginTop={'13px'}>
                                  <NoResultsMessage />
                                </View>
                              )}
                            </>
                          )}
                        </View>
                      )}
                    </View>
                  </>
                )}
              </>
            ) : (
              <View gridArea="detail">
                {showLoader ? (
                  <Loader />
                ) : (
                  <View position={'relative'} overflow={'auto'} height={'100%'} width={'100%'} UNSAFE_className={styles.service_activities}>
                    {columnsData?.length > 0 && rowsData?.length > 0 ? (
                      <EventListTable
                        upComming7DaysEvents={upComing7DaysEvents}
                        past7DaysCompleted={past7DaysCompletedEvents}
                        past3MonthsUnCompleted={past3MonthsUnCompletedEvents}
                        handleTableRowclick={handleTableRowClick}
                        handleEditClick={handleEditClickTable}
                      />
                    ) : (
                      <NoResultsMessage />
                    )}
                  </View>
                )}
              </View>
            )}
          </Grid>
        ) :
          <Grid
            areas={pageView == 'Full' ? ['detail', 'detail'] : ['detail', 'detail']}
            columns={{ base: ['100%'], L: ['100%'] }}
            rows={['auto', '1fr']}
            height="100%"
            width="100%"
            UNSAFE_style={{ backgroundColor: '#f5f6f9', padding: '10px', margin: '0px', overflow: 'hidden' }}
          >
            {pageView == 'Full' ? (
              <>
                {showLoader ? (
                  <Loader />
                ) : (
                  <>
                    <View
                      gridArea="detail"
                      backgroundColor={'static-white'}
                      borderRadius={'large'}
                      UNSAFE_style={detailStyle}
                      width={'100%'}
                      UNSAFE_className={styles.detailView}
                    >
                      {showLoaderDetail ? (
                        <Loader />
                      ) : (
                        <View height="100%" UNSAFE_className={styles.detailsHolder} UNSAFE_style={{ overflow: 'hidden auto' }} marginStart={'10px'}>
                          {selectedItem && (
                            <>
                              {rowsData?.length > 0 ? (
                                <>
                                  <View UNSAFE_className={styles.service_status_bar} UNSAFE_style={{ backgroundColor: selectedItem.statusColor }}></View>
                                  <View height={'2px'}>&nbsp;</View>
                                  <EventDetailsView
                                    event={selectedItem}
                                    productStatusList={eventStatusList}
                                    updateEventStatus={updateEventStatus}
                                    onEdit={handleEditClick}
                                    onDelete={() => setOpen(true)}
                                    updateEventDescription={updateEventDescription}
                                    showUpdateLoader={showUpdateDescLoader}
                                    handleBackClick={() => setShowCards(true)}
                                  />
                                </>
                              ) : (
                                ''
                              )}
                            </>
                          )}
                        </View>
                      )}
                    </View>
                  </>
                )}
              </>
            ) : (
              <View gridArea="detail">
                {showLoader ? (
                  <Loader />
                ) : (
                  <View position={'relative'} overflow={'auto'} height={'100%'} width={'100%'} UNSAFE_className={styles.service_activities}>
                    {columnsData?.length > 0 && rowsData?.length > 0 ? (
                      <EventListTable
                        upComming7DaysEvents={upComing7DaysEvents}
                        past7DaysCompleted={past7DaysCompletedEvents}
                        past3MonthsUnCompleted={past3MonthsUnCompletedEvents}
                        handleTableRowclick={handleTableRowClick}
                        handleEditClick={handleEditClick}
                      />
                    ) : (
                      <NoResultsMessage />
                    )}
                  </View>
                )}
              </View>
            )}
          </Grid>
        )
      }
      <DialogContainer onDismiss={handleAddNewClose}>
        {showAdd && <AddUpdateEvent
          event={selectedDataRow}
          isEdit={isEdit}
          onClose={handleAddNewClose}
          refreshDetailView={refreshDetailView}
          handleRefreshAddNewEvent={handleRefreshAddNewEvent}
          typeOfWorkList={typeofWorkList}
          eventStatusList={eventStatusList}
          userList={userData} />
        }
      </DialogContainer>
      <DeleteConfirmationDialog
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        onConfirm={() => handleEventDelete(selectedItem)}
        itemName={selectedItem?.name}
      />
    </>
  );
}